import React from "react";
import { Row, Col } from "antd";
import { isEmpty } from "lodash";

import { SignUpForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");

const SignUpPage = ({ auth, detailCode, doSignUp }) => {
  const renderSignUpForm = () => <SignUpForm auth={auth} detailCode={detailCode} doSignUp={doSignUp} />;

  return (
    <div className="SignUpPage">
      {!isEmpty(detailCode) ? (
        renderSignUpForm()
      ) : (
        <Row justify="center">
          {!isNordicrouting ? (
            <>
              <Col xs={0} sm={0} md={12}>
                <div
                  className="LeftImg"
                  style={{
                    backgroundImage: "url('/login-logo.jpg')",
                    backgroundSize: "cover",
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={12}>
                {renderSignUpForm()}
              </Col>
            </>
          ) : (
            <Col xs={24} sm={24} md={{ span: 12, offset: 1 }}>
              {renderSignUpForm()}
            </Col>
          )}
        </Row>
      )}
    </div>
  );
};

export default withUnAuth(AuthContainer(SignUpPage));
